export const Background = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative h-screen">
      <div className="absolute inset-0 -z-10 h-full w-full overflow-hidden">
        <WeirdMovingThings />
        <Circle />
      </div>
      <div className="flex min-h-screen w-full flex-col">{children}</div>
    </div>
  );
};

const WeirdMovingThings = () => {
  return (
    <div className="absolute inset-0 -z-10 h-full w-full bg-dark-blue bg-weird-moving-things bg-cover bg-no-repeat opacity-[29%] bg-blend-overlay blur-[20px]" />
  );
};

const Circle = () => {
  return (
    <div
      className="absolute -z-10 aspect-square max-h-screen min-w-[1090px] rounded-full"
      style={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: '0.2',
        background: 'linear-gradient(to bottom, #44009B, #2370CA)',
        filter: 'blur(350px)',
        willChange: 'transform',
      }}
      aria-hidden="true"
    />
  );
};
